<template>
  <div class="status-modal-root">
    <div class="upper-title">
      <slot name="upper-title" />
    </div>

    <div class="picture">
      <img
        src="../../../assets/images/status-in-progress.png"
        alt="progress icon"
        width="184px"
        height="186px"
      />
    </div>

    <div class="title">
      <slot name="title" />
    </div>

    <div class="description">
      <slot name="description" />
    </div>

    <div class="additional-content">
      <slot name="additional-content" />
    </div>

    <div class="actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped lang="scss">
.status-modal-root {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.upper-title {
  color: var(--attention);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 24px */
}

.picture {
  margin-top: 45px;
}

.title {
  margin-top: 50px;
  color: var(--text-1);
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 36.4px */
}

.description {
  margin-top: 5px;
  color: var(--text-6);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.additional-content {
  margin-top: 35px;
}

.actions {
  margin-top: 50px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
</style>
